<template>
  <div class="py-4 container-fluid">
    <MetodoFormulario
      ref="formularioMetodo"
      :metodoId="state.metodoId"
      @closeModal="displayModal(false, true)"
    />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <!-- <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Todos métodos</h5>
                <p class="mb-0 text-sm">
                  Listagem de métodos
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <button type="button" class="mb-0 btn bg-gradient-success btn-sm" @click="displayModal(true)">
                    +&nbsp; Nova método
                  </button>
                </div>
              </div>
            </div>
          </div> -->
          <div class="card-body">
            <MyTable :data="state.metodos" :columns="columns" :itemsPerPage="12">
              <template v-slot:row="{ row }">
                <td class="text-sm pointer">
                  {{ row.name }}
                </td>
                <td class="text-center">
                  {{ $filters.datePtbr(row.created_at) }}
                </td>
                <td class="text-sm">
                  <div class="float-end">
                    <div>
                      <span
                        class="pointer"
                        data-bs-toggle="tooltip"
                        :data-bs-original-title="$t('editMethod')"
                        :title="$t('editMethod')"
                        @click="editarMetodo(row.id)"
                      >
                        <i class="fas fa-pen text-secondary me-2"></i>
                        {{ $t('edit') }}
                      </span>
                    </div>
                    <div>
                      <span
                        class="pointer"
                        data-bs-toggle="tooltip"
                        :data-bs-original-title="$t('deleteMethod')"
                        :title="$t('deleteMethod')"
                        @click="deletarMetodo(row)"
                      >
                        <i class="fas fa-trash text-secondary me-2"></i>
                        {{ $t('delete') }}
                      </span>
                    </div>
                  </div>
                </td>
              </template>
            </MyTable>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject } from 'vue'
import { useStore } from 'vuex'
import metodoRepository from '../../../../../services/api/metodoRepository'
import MyTable from '../../../../../components/MyTable.vue'
import { useRouter, useRoute } from 'vue-router'
import MetodoFormulario from './MetodoFormulario.vue'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    MyTable,
    MetodoFormulario,
  },
  setup() {
    // const router = useRouter()
    // const route = useRoute()
    const formularioMetodo = ref(null)
    const swal = inject('$swal')
    const store = useStore()
    const { t } = useI18n()
    const scrollToMetodo = () => {
      if (formularioMetodo.value) {
        formularioMetodo.value.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      listarMetodos()
    })

    //const hidePassword = ref(true)
    // const passwordFieldIcon = computed(() => hidePassword.value ? ['fa', 'eye'] : ['fa', 'eye-slash']);
    // const passwordFieldType = computed(() => hidePassword.value ? "password" : "text");

    let modalVisible = ref(false)
    const columns = ref([
      {
        label: t('name'),
        field: 'nome',
        sortable: 'nome',
      },
      {
        label: t('registrationDate'),
        field: 'dataCadastro',
      },
      {
        label: t('actions'),
        field: 'actions',
      },
    ])

    const state = reactive({
      metodoId: 0,
      metodos: [],
      metodoId: 0,
    })

    const listarMetodos = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      metodoRepository
        .MetodoGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          state.metodos = []

          if (response.data.success) {
            state.metodos = response.data.data
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorListingMethods'),
            text: error.message,
          })
        })
    }

    function editarMetodo(id) {
      // console.log(id)
      state.metodoId = id
      // console.log(state.metodoId)
      //router.push(`/cadastros/metodo/${id}`);
    }

    function deletarMetodo(item) {
      swal({
        title: t('areYouSure'),
        text: t('doYouWantToDelete', { name: item.name }),
        showCancelButton: true,
        confirmButtonText: t('yesDelete'),
        cancelButtonText: t('noCancel'),
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarMetodoConfirma(item.id)
        }
      })
    }

    function deletarMetodoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      metodoRepository
        .MetodoDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: t('removed'),
              text: t('methodRemovedSuccessfully'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              listarMetodos()
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: t('errorDeletingMethod'),
            text: error.message,
          })
        })
    }

    function displayModal(display = true, refresh = false) {
      state.metodoId = 0
      modalVisible.value = display
      if (refresh) {
        listarMetodos()
      }
    }

    return {
      state,
      columns,
      editarMetodo,
      deletarMetodo,
      displayModal,
      modalVisible,
      formularioMetodo,
      scrollToMetodo,
    }
  },
}
</script>
